import { useTheme } from '@emotion/react';
import { faHistory } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { StyledAuditHistoryButton } from '~/common/components/AuditHistoryButton';
import Flex from '~/common/components/Flex';
import Stack from '~/common/components/Stacks/Stack';
import Text from '~/common/components/Texts/Text';
import { useAuditHistoryWindow } from '~/common/hooks/useAuditHistoryWindow';
import { AuditHistoryPageEnum } from '~/pages/AuditHistory/constants';

type Loan1003FormSectionProps = {
  title: string;
  customMarginTop?: string;
  children: React.ReactNode;
  isHidden?: () => boolean;
  isAuditHistoryEnabled?: boolean;
};

export default function Loan1003FormSection({
  title,
  children,
  isHidden = () => false,
  customMarginTop,
  isAuditHistoryEnabled = false,
}: Readonly<Loan1003FormSectionProps>) {
  const { handleChangePageId } = useAuditHistoryWindow();
  const theme = useTheme();
  if (isHidden()) return null;
  return (
    <Stack
      component="section"
      aria-label={title}
      width={'100%'}
      boxSizing="border-box"
      marginTop={
        customMarginTop ? `${customMarginTop} !important` : 'unset !important'
      }
      display="flex"
      justifyContent="space-between"
    >
      <Text
        style={{
          width: '100%',
          padding: '.25rem',
          marginBottom: '1rem',
          color: theme.colors?.blue[600],
          borderBottom: `0.3rem solid ${theme.colors?.blue[600]}`,
        }}
        fontSize={'2xl'}
      >
        <Flex justifyContent="space-between">
          {title}
          {isAuditHistoryEnabled && (
            <StyledAuditHistoryButton
              rightIcon={<FontAwesomeIcon icon={faHistory} />}
              data-testid="audit-history--button"
              aria-label={'Date Tracking Audit History'}
              isPrimary={false}
              onClick={() =>
                handleChangePageId(AuditHistoryPageEnum.SUBORDINATE_FINANCING)
              }
            />
          )}
        </Flex>
      </Text>
      {children}
    </Stack>
  );
}
